<template>
  <div class="my_shop">
    <van-row>
      <van-notice-bar :text="$t('shop.Conditions_opening_small_shops')"/>
      <van-cell :title="$t('shop.Complete_certification')" size="large" :label="auth_status"/>
      <van-cell :title="$t('shop.Deposit')" :value="open_my_shop_margin_num" size="large" :label="margin_status_str"/>
      <van-button @click="clickOpenShop" type="primary" round block>{{ $t('shop.Apply_open_small_shop') }}</van-button>
    </van-row>
    <van-overlay :show="showOverlay" @click="show = false">
      <div class="shop_auth_block" @click.stop>
        <van-col span="24">
          <van-col span="24" class="my_shop_auth_top_view">
            <img src="./../assets/img/bg_shop_info_auth.png" class="my_shop_auth_top"/>
          </van-col>
        </van-col>
        <van-row>
          <van-col span="24">{{ $t('shop.application_under_review') }}</van-col>
        </van-row>
      </div>
    </van-overlay>
  </div>
</template>

<script>
    import axios from "axios";
    import { Toast, Dialog} from 'vant';
    export default {
        name: "my_shop",
        data() {
            return {
                showOverlay: false,
                open_my_shop_margin_num: 0,
                auth_status: '',
                is_authentication: 0,
                satisfy: 0,
                margin_status: 0,
                margin_status_str: '',
            }
        },
        created: function () {
            document.title = this.$t('shop.Opening_small_shop_title');
            this.initData();
        },
        methods: {
            clickOpenShop: function () {
                if (this.is_authentication === 0) {
                    Toast(this.$t('shop.Not_meeting_opening_conditions') );
                    return
                }
                if (this.satisfy !== 1 && this.margin_status !== 1) {
                    Dialog.confirm({
                        title: this.$t('shop.Tips'),
                        message: this.$t('shop.Confirm_payment') + this.open_my_shop_margin_num + this.$t('shop.bond'),
                        confirmButtonText: this.$t('btn.submit'),
                        cancelButtonText: this.$t('btn.cancel'),
                    })
                    .then(() => {
                        this.requestMargin();
                    })
                    .catch(() => {

                    });
                    return;
                }
                const uid = this.$route.query.uid
                const token = this.$route.query.token
                this.$router.push({path: '/createShop', query: { uid: uid, token: token}});
            },
            //请求缴纳保证金
            requestMargin: function () {
                const uid = this.$route.query.uid;
                const token = this.$route.query.token;
                axios.get(this.baseUrlApi + "mapi/public/index.php/api/shop_api/pay_gold", {
                    params: {
                      uid: uid,
                      token: token,
                    }
                }).then(res => {
                    console.log(res.data);
                    Toast(res.data.msg);
                    if (res.data.code === 1) {
                      this.$router.push({path: '/createShop', query: { uid: uid, token: token}});
                    }
                });
            },
            initData: function () {
                const uid = this.$route.query.uid;
                const token = this.$route.query.token;
                axios.get(this.baseUrlApi + "mapi/public/index.php/api/shop_api/my_shop_index", {
                    params: {
                      uid: uid,
                      token: token,
                    }
                }).then(res => {
                    console.log(res.data);
                    if (res.data.code === 0) {
                        Toast(res.data.msg);
                        return;
                    }
                    this.is_authentication = res.data.data.matchmaker_yuelao_id;
                    if (res.data.data.matchmaker_yuelao_id !== 0) {
                        this.auth_status = this.$t('shop.Certified')
                    } else {
                        this.auth_status = this.$t('Not_certified')
                    }
                    this.satisfy = res.data.data.satisfy;
                    this.margin_status = res.data.data.margin_status;
                    if (this.margin_status === 1) {
                        this.margin_status_str = this.$t('shop.Paid');
                    } else {
                        this.margin_status_str = this.$t('shop.Unpaid');
                    }
                    this.open_my_shop_margin_num = res.data.data.open_my_shop_margin_num + res.data.data.currency_name;
                });
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/my_shop.vue